import { API } from 'utils/API';

const fetchMenu = async (key, { menuId, lang }) => {
  const { data } = await API.get(
    `/menus/${menuId}/detail`,
    lang && {
      headers: {
        'Accept-Language': lang,
      },
    }
  );
  return data;
};

const fetchRestaurant = async (key, { restaurantId }) => {
  const { data } = await API.get(`restaurants/${restaurantId}/menus`);
  return data;
};

export { fetchMenu, fetchRestaurant };
